// extracted by mini-css-extract-plugin
export default {"tiles":"asW28","box":"vJdyS","fullSize":"qtn6b","descriptionText":"jzRau","valueText":"t39MV","value":"qH1FB","text":"o4hNn","tooltip":"L7zBc"};